import { useQueryParams } from '@/hooks';
import { useEffect, useMemo, useState } from 'react';
import { PreparePackageFilter } from '../models';

const usePreparePackageFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: PreparePackageFilter = useMemo(
    () => ({
      shippingId: '',
      phoneNumber: '',
      dateAgendaFrom: new Date(),
      dateAgendaTo: new Date(),
      pickupAttendance: '',
    }),
    []
  );

  const [filter, setFilter] = useState<PreparePackageFilter>(() => {
    const dateAgendaFrom = getQueryParam('dateAgendaFrom') || '';
    const dateAgendaTo = getQueryParam('dateAgendaTo') || '';

    return {
      shippingId: getQueryParam('shippingId') || initialFilter.shippingId,
      phoneNumber: getQueryParam('phoneNumber') || initialFilter.phoneNumber,
      dateAgendaFrom: dateAgendaFrom
        ? new Date(dateAgendaFrom)
        : initialFilter.dateAgendaFrom,
      dateAgendaTo: dateAgendaTo
        ? new Date(dateAgendaTo)
        : initialFilter.dateAgendaTo,
      pickupAttendance: getQueryParam('pickupAttendance') || initialFilter.pickupAttendance,
    };
  });

  useEffect(() => {
    setQueryParams({
      shippingId: filter.shippingId,
      phoneNumber: filter.phoneNumber,
      dateAgendaFrom: filter.dateAgendaFrom.toISOString(),
      dateAgendaTo: filter.dateAgendaTo.toISOString(),
      pickupAttendance: filter.pickupAttendance,
    });
  }, [filter]);

  return {
    initialFilter,
    filter,
    setFilter,
  };
};

export default usePreparePackageFilter;
